"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryCandlestick", {
  enumerable: true,
  get: function () {
    return _victoryCandlestick.default;
  }
});
Object.defineProperty(exports, "Candle", {
  enumerable: true,
  get: function () {
    return _candle.default;
  }
});

var _victoryCandlestick = _interopRequireDefault(require("./victory-candlestick"));

var _candle = _interopRequireDefault(require("./candle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-candlestick/lib/index.js
// module id = 1854
// module chunks = 0